import {
  orderBy
} from '@progress/kendo-data-query';
import {
  saveExcel
} from '@progress/kendo-vue-excel-export';
import api from '../../services/api';


export default {
  components: {

  },
  data: function () {
    return {
      date: "12/07/2019",
      loading: false,
      items: [],
      skip: 0,
      take: 10,
      total: 0,
      pageSize: 20,
      pageIndex: 0,
      pageable: {
        buttonCount: 5,
        info: true,
        type: 'numeric',
        pageSizes: false,
        previousNext: true
      },
      sort: [],
      filter: {
        logic: "and",
        filters: [{
            field: "UnitPrice",
            operator: "neq",
            value: 18
          },
          {
            field: "FirstOrderedOn",
            operator: "gte",
            value: new Date("1996-10-10")
          }
        ]
      }
    }
  },
  created() {
    this.getData(1);
  },
  methods: {
    sortChangeHandler: function (e) {
      this.sort = e.sort;

      this.getData();
    },
    filterChange: function (ev) {
      this.filter = ev.filter;
    },
    pageChangeHandler: function (event) {

      this.skip = event.page.skip;
      this.take = event.page.take;

      if (this.skip === 0) {
        this.pageIndex = 0
      }
      this.pageIndex = this.skip / this.take;

      this.getData();

    },
    exportExcel() {
      saveExcel({
        data: this.items,
        fileName: "test",
        columns: [{
            field: 'id'
          },
          {
            field: 'name',
            title: 'name'
          }
        ]
      });
    },
    getData: function () {
      var self = this;
      this.loading = true;



      api.getBrandsData(this.pageIndex, this.sortColumn, this.sortDirection).then(res => {

        self.loading = false;

        self.items = res.items.map(function (item) {
          return {
            id: item.id,
            name: item.name
          }
        });

        self.total = res.totalCount;
      });
    }
  },

  computed: {
    result: {
      get: function () {
        var self = this;

        var orderedResult = orderBy(self.items, this.sort);
        //var filteredResult = filterBy(orderedResult, this.filter);
        return orderedResult;
      }
    },
    columns: function () {
      return [{
          field: 'id',
          filterable: false,
          title: 'id',
          width: '50px'
        },
        {
          field: 'name',
          title: 'name'
        }
      ]
    }
  },
}